import { render, staticRenderFns } from "./OrganisationDetails.vue?vue&type=template&id=b726a810&"
import script from "./OrganisationDetails.vue?vue&type=script&lang=js&"
export * from "./OrganisationDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports